import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * A downgraded NGX wrapper for the disabledInteractive directive
 * NOTE: Do not use this wrapper if in NGX; use the directive directly instead
 */
@Component({
	selector: 'disabled-interactive-wrapper',
	template: `
		<button
			type="button"
			[disabled]="isDisabled"
			[disabledInteractive]="true"
			[attr.class]="buttonClass"
			[attr.aria-label]="buttonAriaLabel"
			[attr.data-cy]="testId"
			[attr.analytics-on]="analyticsOn"
			[attr.analytics-category]="analyticsCategory"
			[attr.analytics-event]="analyticsEvent"
			(click)="handleClick()">
			{{ buttonLabel }}
		</button>
	`,
	standalone: false
})
export class DisabledInteractiveWrapperComponent {
	@Input() public analyticsCategory?: string | null;
	@Input() public analyticsEvent?: string | null;
	@Input() public analyticsOn?: string | null;
	@Input() public buttonAriaLabel?: string | null;
	@Input() public buttonLabel = '';
	@Input() public buttonClass = '';
	@Input({ transform: booleanAttribute }) public isDisabled = false;
	@Input() public testId?: string | null;
	@Output() public onClick = new EventEmitter<void>();

	public handleClick (): void {
		this.onClick.emit();
	}
}
